// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50f19def","453":"437e0b50","667":"74ea65eb"}[chunkId] + ".chunk.js";
};